import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { BusinessIcon } from '@emburse/embark-icons';
import { SelectionModal } from '../../components';
import { $t, useTranslation } from '../../hooks/useTranslation';
import { getCompaniesForSwitchAsAdmin, switchCompanyAsAdmin } from '../../api/switchCompany';
import useAccountConfig from '../../hooks/useAccountConfig';
function SwitchCompanyModal({ isOpen, onClose }) {
    useTranslation();
    const { accountConfig } = useAccountConfig();
    const [companyList, setCompanyList] = useState([]);
    const [errorFound, setErrorFound] = useState('');
    const [loading, setLoading] = useState(false);
    const onCloseHandler = () => {
        onClose(false);
    };
    const onSelectionHandler = useCallback(async (item) => {
        try {
            setLoading(true);
            await switchCompanyAsAdmin(accountConfig.Emp.PK, parseInt(item.ID, 10));
            setLoading(false);
            onClose(false);
            window.location.href = './Home.aspx';
        }
        catch (error) {
            setErrorFound(error.message);
        }
    }, [accountConfig, onClose]);
    const getCompaniesForSwitch = useCallback(async () => {
        try {
            const switchableCompanies = await getCompaniesForSwitchAsAdmin(accountConfig.Emp.PK);
            const selectionList = switchableCompanies.map((item) => ({
                Label: item.Name,
                ID: item.PK.toString()
            }));
            setCompanyList(selectionList);
        }
        catch (error) {
            setErrorFound(error.message);
        }
    }, [accountConfig]);
    useEffect(() => {
        if (isOpen && !errorFound && companyList.length === 0) {
            getCompaniesForSwitch();
        }
    }, [isOpen, companyList, errorFound, accountConfig, getCompaniesForSwitch]);
    return (_jsx(SelectionModal, { title: $t('Switch Company'), caption: $t(`Select the company you would like to switch to. You will be automatically authenticated into your corresponding \
                user account in the other company. Return to the original user account at any time by selecting "Switch Company" in the user drop down menu.`), items: companyList, listTitle: `Certify ${$t('Accounts')}`, listIcon: BusinessIcon, showFilter: false, selectedItem: $t(`${accountConfig.Emp.Company.Name}`), selectedCaption: $t('Currently logged in'), error: errorFound, isOpen: isOpen, loading: loading, onSelection: onSelectionHandler, onClose: onCloseHandler }));
}
export default SwitchCompanyModal;
